module.exports = __webpack_public_path__ + "8f719a67a528c19790f907b7f93acdc4.svg";